import { EntityConfig } from 'angular-odata';

//#region ODataApi Imports
import { GroupTreeAttribute } from './grouptreeattribute.entity';
//#endregion

export const GroupTreeAttributeConfig = {
  name: "GroupTreeAttribute",
  annotations: [],
  fields: {
    groupTreeId: {type: 'Edm.Int32'},
    attributeId: {type: 'Edm.Int32'},
    sortValue: {type: 'Edm.Int32'},
    statusId: {type: 'Edm.Int32'},
    statusTypeId: {type: 'Edm.Int32'},
    statusAt: {type: 'Edm.DateTimeOffset'},
    statusBy: {type: 'Edm.String'},
    createdBy: {type: 'Edm.String'},
    id: {type: 'Edm.Int32', key: true, ref: 'id', nullable: false},
    groupTree: {type: 'entities.schema.GroupTree', navigation: true, field: 'groupTreeId', ref: 'id'},
    attribute: {type: 'entities.schema.Attribute', navigation: true, field: 'attributeId', ref: 'id'},
    status: {type: 'entities.settings.Status', navigation: true, field: 'statusId', ref: 'id'},
    statusType: {type: 'entities.settings.StatusType', navigation: true, field: 'statusTypeId', ref: 'id'}
  }
} as EntityConfig<GroupTreeAttribute>;